<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="createReport()" type="button" class="btn btn-primary">Create Report</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>

        <pagination-report-listing :key="componentKey"></pagination-report-listing>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="refresh()" type="button" class="btn btn-primary">Refresh</button>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from "axios";

    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";

    export default {
        name: "pagination-com-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false,
                componentKey: 0
            };
        },
        methods: {
            createReport: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
                this.refresh();
            },
            refresh: function() {
                axios.get(this.baseUrl + '/pagination/refresh?channelId=' + dataObject.channel.id )
                    .then(function() {
                        this.componentKey += 1;
                    })
                    .catch(function() {
                        console.log('Refreshing failed');
                    });
                this.componentKey += 1;
            },
            setItems: function () {
                let cvs = this.channelvalues;
                let cfo = this.channeloptions;
                this.channel.items = [
                    {
                        groupingName : "Pagination.com",
                        groupItems : [
                            {
                                name : "profile_id",
                                label : "Profile",
                                required : true,
                                type : "select",
                                disabled : false,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'profile_id')) ? cvs.json_options.configuration.profile_id  : "",
                                options : (cfo.profiles) ? cfo.profiles : [],
                            },
                        ]
                    }
                ];
            },
        },
        mounted() {
            this.setItems();
        },
    };
</script>
